import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import useAxios from "../../hooks/useAxios";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import swal from "sweetalert";

const CostCenterItemDescriptionsComponent = ({ costCenterId }) => {

    const [data, setData] = useState({
        item_code: '',
        description: '',
        cost_center_ids: []
    });

    const [selectAll, setSelectAll] = useState(false);

    const [show, setShow] = useState(false);

    const [showModal, setShowModal] = useState(false);

    const [costCentersFilters, setCostCentersFilters] = useState({ page: 1, perPage: 1000, name: '' });

    const [{ data: descriptionsData, loading: loadingDescriptions }, getDescriptions] = useAxios({ url: `/cost-center-item-descriptions` }, { useCache: false, manual: true });

    const [{ loading: loadingStoreDescriptions }, storeDescriptions] = useAxios({ url: `/cost-center-item-descriptions`, method: 'POST' }, { useCache: false, manual: true });

    const [{ loading: loadingDeleteDescription }, deleteDescription] = useAxios({ method: 'DELETE' }, { useCache: false, manual: true });

    const [{ data: costCentersResponse, loading }, getCostCenters] = useAxios({ url: `/cost-centers`, params: costCentersFilters }, { useCache: false });

    useEffect(() => {
        if (show) {
            getDescriptions({ params: { cost_center_id: costCenterId } });
        }
    }, [show])

    useEffect(() => {
        setData((oldData) => {
            return {
                ...oldData,
                cost_center_ids: selectAll ? costCentersResponse?.data?.map((costCenter) => `${costCenter?.id}`) : []
            }
        })
    }, [selectAll])

    const handleChange = (e) => {
        setData((oldData) => {
            return {
                ...oldData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleAdd = () => {
        setData({ item_code: '', description: '', cost_center_ids: [costCenterId] });
        setShowModal(true);
    }

    const handleUpdate = (description) => {
        setData({ item_code: description?.item_code, description: description?.description, cost_center_ids: [costCenterId] });
        setShowModal(true);
    }

    const handleCostCenter = (e) => {
        if (data?.cost_center_ids?.includes(e.target.value)) {
            setData((oldData) => {
                return {
                    ...oldData,
                    cost_center_ids: oldData.cost_center_ids?.filter((cost_center_id) => cost_center_id != e.target.value)
                }
            })
        } else {
            setData((oldData) => {
                return {
                    ...oldData,
                    cost_center_ids: [...oldData?.cost_center_ids, e.target.value]
                }
            })
        }
    }

    const handleDelete = (descriptionId) => {
        swal({
            title: "¿Estas Seguro(a)?",
            text: "¿Quieres eliminar el registro seleccionado?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                deleteDescription({ url: `/cost-center-item-descriptions/${descriptionId}` }).then((response) => {
                    getDescriptions({ params: { cost_center_id: costCenterId } });
                });
            }
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        storeDescriptions?.({ data }).then(() => {
            setShowModal(false);
            getDescriptions({ params: { cost_center_id: costCenterId } });
        });
    }

    return (
        <>
            <div className="card">
                <div className="card-header">
                    <div className="d-flex w-100 align-items-center">
                        <h4>
                            Descripciones de los haberes
                        </h4>
                        <button className="btn btn-xs btn-primary ms-auto" onClick={() => setShow(oldValue => !oldValue)}>
                            {
                                show ?
                                    <FaChevronUp />
                                    :
                                    <FaChevronDown />
                            }
                        </button>
                    </div>
                </div>
                {
                    show &&
                    <div className="card-body">
                        {
                            loadingDescriptions ?
                                <div className="spinner">
                                    <div className="double-bounce1 bg-primary"></div>
                                    <div className="double-bounce2 bg-primary"></div>
                                </div>
                                :
                                <>
                                    <div>
                                        <div className="table-responsive">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            Haber
                                                        </th>
                                                        <th>
                                                            Descripción
                                                        </th>
                                                        <th>
                                                            Acciones
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        descriptionsData?.length > 0 ?
                                                            descriptionsData?.map((description) => {
                                                                return (
                                                                    <tr key={`descripciones-${description?.id}`}>
                                                                        <td>
                                                                            {description?.item_code}
                                                                        </td>
                                                                        <td dangerouslySetInnerHTML={{ __html: description?.description }}></td>
                                                                        <td>
                                                                            <div class="btn-group" role="group">
                                                                                <button onClick={() => handleUpdate(description)} type="button" className="btn btn-primary btn-sm">
                                                                                    Editar
                                                                                </button>
                                                                                <button disabled={loadingDeleteDescription} onClick={() => handleDelete(description?.id)} type="button" className="btn btn-danger btn-sm">
                                                                                    {loadingDeleteDescription ? 'Cargando' : 'Eliminar'}
                                                                                </button>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                            :
                                                            <tr>
                                                                <td colSpan={3} className="text-center">
                                                                    No se encontrarón resultados.
                                                                </td>
                                                            </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="text-center">
                                            <button className="btn btn-success" onClick={handleAdd}>
                                                Agregar
                                            </button>
                                        </div>
                                    </div>
                                </>
                        }
                    </div>
                }
            </div >
            <Modal show={showModal} onHide={() => setShowModal(false)} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Agregar descripción del item
                    </Modal.Title>
                </Modal.Header>
                <form onSubmit={handleSubmit}>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-md-12 mb-3">
                                <input type="text" className="form-control" placeholder="Código del haber" value={data?.item_code} name="item_code" onChange={handleChange} />
                            </div>
                            <div className="col-md-12 mb-3">
                                <CKEditor
                                    editor={Editor}
                                    data={data?.description}
                                    onChange={(event, editor) => {
                                        const descriptionData = editor.getData();
                                        setData((oldData) => {
                                            return {
                                                ...oldData,
                                                description: descriptionData
                                            }
                                        })
                                    }}
                                />
                            </div>
                            <div className="col-md-12">
                                <div className="row align-items-center">
                                    <div className="col-md-8 mb-3">
                                        <h6>
                                            Aplicar a los centros de costos:
                                        </h6>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Buscar..."
                                            value={costCentersFilters?.name}
                                            onChange={(e) => setCostCentersFilters(old => ({ ...old, name: e.target.value }))}
                                        />
                                    </div>
                                    {
                                        loading ? 'Cargando...' :
                                            costCentersResponse?.data?.length > 0 ?
                                                <>
                                                    <div className="col-md-3 mb-3">
                                                        <div class="form-check" style={{ cursor: 'pointer' }}>
                                                            <input
                                                                onChange={(e) => setSelectAll(old => !old)}
                                                                class="form-check-input"
                                                                type="checkbox"
                                                                checked={selectAll}
                                                                id="select-all"
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                            <label class="form-check-label" for="select-all" style={{ cursor: 'pointer' }}>
                                                                Seleccionar todos
                                                            </label>
                                                        </div>
                                                    </div>
                                                    {
                                                        costCentersResponse?.data?.map((costCenter, i) => {
                                                            return (
                                                                <div className="col-md-3 mb-3" key={i}>
                                                                    <div class="form-check" style={{ cursor: 'pointer' }}>
                                                                        <input
                                                                            onChange={handleCostCenter}
                                                                            class="form-check-input"
                                                                            type="checkbox"
                                                                            value={costCenter?.id}
                                                                            checked={data?.cost_center_ids?.includes(`${costCenter?.id}`)}
                                                                            id={costCenter?.id}
                                                                            style={{ cursor: 'pointer' }}
                                                                        />
                                                                        <label class="form-check-label" for={costCenter?.id} style={{ cursor: 'pointer' }}>
                                                                            {costCenter?.name}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </>
                                                :
                                                'No se encontrarón resultados.'
                                    }
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>
                            Cerrar
                        </Button>
                        <button className="btn btn-primary" disabled={loadingStoreDescriptions}>
                            {
                                loadingStoreDescriptions ?
                                    'Cargando'
                                    :
                                    'Guardar Cambios'
                            }
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    )
}

export default CostCenterItemDescriptionsComponent;